



































































import { Vue, Component } from 'vue-property-decorator'
import _ from 'lodash'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
import {IUser} from '@/store/modules/views/user/states'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import { ICenter } from '@/store/modules/views/center/states'

@Component
export default class User extends VueExtendedBaseComponent {
  private options: OptionTable = {
    page: 1,
    sortBy: ['updatedAt'],
    sortDesc: [true],
    itemsPerPage: 10,
    search: '',
  }
  private id = ''
  private name = ''
  private email = ''
  private currentData = {}
  private filters = {}
  private loadingDataTable = true
  private createDialog = false
  private editDialog = false
  private deleteDialog = false
  private resetDialog = false
  private clearTimeoutValue: NodeJS.Timeout = setTimeout(() => undefined, 100)

  get headers(): Array<{ text: string; value: string }> {
    return this.headerLists
  }

  get caregiverLevels() {
    return {
      10: 'ขั้นพื้นฐาน',
      20: 'ขั้นสูง',
    }
  }

  get items() {
    return this.itemLists
  }

  get paginationLists() {
    return this.pagination
  }

  @Getter('center/centerById')
  private centerById!: {[centerId: string]: ICenter}

  @Action('user/getUserListByRoleCaregiver')
  private getUserList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
    },
    id: string,
  }) => void

  @Getter('user/headerListsCaregiver')
  private headerLists!: Array<{ text: string; value: string }>

  @Getter('user/caregiverListsByRole')
  private itemLists!: () => void

  @Getter('user/paginationCaregiver')
  private pagination!: () => void

  private async getList() {
    this.loadingDataTable = true
    await this.getUserList({
      headers: {
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sortBy: _.get(this.options, 'sortBy[0]', 'createdAt'),
        sortDesc: _.get(this.options, 'sortDesc[0]', true),
        search: Buffer.from(this.options.search).toString('base64'),
        filter: Buffer.from(JSON.stringify(this.filters)).toString('base64'),
      },
      id: '8de180b16237428082fcca28913aefcd',
    })
    this.loadingDataTable = false
  }
  private mapAddressText(text: IUser['address']) {
    return this.mapAddress(text)
  }

  private doGetLists() {
    clearTimeout(this.clearTimeoutValue)
    this.loadingDataTable = true
    this.clearTimeoutValue = setTimeout(this.getList, 1000)
  }

  private openDialog(user: {name: string, email: string, id: string}, modelDialog: 'editDialog' | 'resetDialog' | 'deleteDialog') {
    this.currentData = _.cloneDeep(user)
    this[modelDialog] = true
  }

  private addNewCaregiverDialog() {
    this.createDialog = true
  }

  private created() {
    this.getList()
  }
}
